import { z } from 'zod'
import { AccountIdSchema } from '../ids'
import { TinyUserSchema } from '../entity'

export const NotificationAccountDisplaySchema = z.object({
  accountId: AccountIdSchema,
  name: z.string(),
  address: z.string().optional(),
})
export const NotificationDisplaySchema = z.object({
  title: z.string(),
  body: z.string(),
  actor: TinyUserSchema.optional(),
  account: NotificationAccountDisplaySchema.optional(),
  eventTitle: z.string().optional(),
  areaName: z.string().optional(),
  redacted: z.boolean(),
})
export type NotificationDisplay = z.infer<typeof NotificationDisplaySchema>
export type NotificationAccountDisplay = z.infer<typeof NotificationAccountDisplaySchema>
